import React, { FC, ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router';
import { localizeType } from '../../commonType';
import { setNavigation } from '../../features/sessionManager/sessionManagerSlice';
import {
  OFFER_CONFIRMATION_PATH,
  OFFER_CONTACT_INFO_PATH,
  OFFER_DATES_PATH,
  OFFER_DESTINATION_PATH,
  OFFER_ELIGIBILITY_PATH,
  OFFER_REVIEW_PATH,
  // eslint-disable-next-line prettier/prettier
  VIEW_OFFERS_PATH
} from '../../util/strings';
import withLocalization from '../hoc/withLocalization';
import './OfferNavigation.scss';

interface OfferNavigationProps {
  localize?: localizeType;
  stepIndex: any;
  currentStep: NavigationSteps;
  hasMultipleOffers: boolean;
  history?: any;
}
interface NavigationStep {
  stepKey: NavigationSteps;
  stepTextKey: string;
  isIncluded: boolean;
  navigationUrl: string;
}
export enum NavigationSteps {
  // eslint-disable-next-line no-unused-vars
  OFFER_DESTINATION,
  // eslint-disable-next-line no-unused-vars
  OFEFR_DETAILS,
  // eslint-disable-next-line no-unused-vars
  OFFER_DATES,
  // eslint-disable-next-line no-unused-vars
  OFFER_ELIGIBILITY,
  // eslint-disable-next-line no-unused-vars
  OFFER_CONTACT_INFO,
  // eslint-disable-next-line no-unused-vars
  OFFER_REVIEW,
  // eslint-disable-next-line no-unused-vars
  OFFER_CONFIRMATION,
  // eslint-disable-next-line no-unused-vars
  OFFER_SEARCH,
}

const navigationStepCollection: NavigationStep[] = [
  {
    stepKey: NavigationSteps.OFFER_DESTINATION,
    stepTextKey: 'preview-sales-engine.static-content.copy.navigation-bar.select-destinatio',
    isIncluded: true,
    navigationUrl: OFFER_DESTINATION_PATH,
  },
  {
    stepKey: NavigationSteps.OFEFR_DETAILS,
    stepTextKey: 'preview-sales-engine.static-content.copy.navigation-bar.select-offer',
    isIncluded: true,
    navigationUrl: VIEW_OFFERS_PATH,
  },
  {
    stepKey: NavigationSteps.OFFER_DATES,
    stepTextKey: 'preview-sales-engine.static-content.copy.navigation-bar.select-dates',
    isIncluded: true,
    navigationUrl: OFFER_DATES_PATH,
  },
  {
    stepKey: NavigationSteps.OFFER_ELIGIBILITY,
    stepTextKey: 'preview-sales-engine.static-content.copy.navigation-bar.eligibility',
    isIncluded: true,
    navigationUrl: OFFER_ELIGIBILITY_PATH,
  },
  {
    stepKey: NavigationSteps.OFFER_CONTACT_INFO,
    stepTextKey: 'preview-sales-engine.static-content.copy.navigation-bar.contact-information',
    isIncluded: true,
    navigationUrl: OFFER_CONTACT_INFO_PATH,
  },
  {
    stepKey: NavigationSteps.OFFER_REVIEW,
    stepTextKey: 'preview-sales-engine.static-content.copy.navigation-bar.review',
    isIncluded: true,
    navigationUrl: OFFER_REVIEW_PATH,
  },
  {
    stepKey: NavigationSteps.OFFER_CONFIRMATION,
    stepTextKey: 'preview-sales-engine.static-content.copy.navigation-bar.confirmation',
    isIncluded: true,
    navigationUrl: OFFER_CONFIRMATION_PATH,
  },
  {
    stepKey: NavigationSteps.OFFER_SEARCH,
    stepTextKey: '',
    isIncluded: false,
    navigationUrl: '/',
  },
];

const OfferNavigation: FC<OfferNavigationProps> = (props: OfferNavigationProps): ReactElement => {
  const { localize, currentStep, hasMultipleOffers } = props;
  const dispatch = useDispatch();
  if (!hasMultipleOffers) {
    navigationStepCollection[0].isIncluded = false;
  } else {
    navigationStepCollection[0].isIncluded = true;
  }
  let currentStepIndex = 0;
  for (let index = 0; index <= navigationStepCollection.length; index++) {
    if (navigationStepCollection[index].stepKey === currentStep) {
      break;
    }
    currentStepIndex++;
  }
  let loopIndex: number = 0;
  const onClickButton = (navigationUrl) => {
    dispatch(setNavigation());
    props.history.push(navigationUrl);
  };
  const getNavItems = navigationStepCollection.map((e, index) => {
    if (e.isIncluded) {
      let buttonClassName = e.stepKey === currentStep ? 'nav-link active upperCase' : 'nav-link upperCase';
      let buttonEnableStatus = !(loopIndex < currentStepIndex);
      buttonEnableStatus = currentStep === NavigationSteps.OFFER_CONFIRMATION ? true : buttonEnableStatus;
      loopIndex = loopIndex + 1;
      return (
        <li key={index} className="nav-item">
          <button
            key={loopIndex}
            disabled={buttonEnableStatus}
            className={buttonClassName}
            onClick={() => onClickButton(e.navigationUrl)}
          >
            {loopIndex}
            {'. '} {localize ? localize(e.stepTextKey) : ''}
          </button>
        </li>
      );
    } else {
      return '';
    }
  });
  return (
    <React.Fragment>
      <div className="navBg">
        <div className="container nav-container">
          <ul className="nav nav-pills">{getNavItems}</ul>
        </div>
      </div>
    </React.Fragment>
  );
};
export default withRouter(withLocalization(OfferNavigation));
